export default __webpack_public_path__ + "static/media/Icon4_On.b91c1276.png";